export const TVService = 'REACT_APP_GET_TOYA_TV_SERVICE'
// export const VODService = 'REACT_APP_GET_TOYA_VOD_SERVICE'
export const VODService = 'REACT_APP_GET_TOYA_VOD_SERVICE'
export const EPGService = 'REACT_APP_GET_TOYA_EPG_SERVICE'
export const LoginAndProfileCodespot =
    'REACT_APP_GET_TOYA_LOGIN_AND_PROFILE_SERVICE'
